module.exports = __webpack_public_path__ + "static/media/ensinoSeta.3a87081c.png";